import script from "./return-item-report.vue?vue&type=script&lang=ts&setup=true"
export * from "./return-item-report.vue?vue&type=script&lang=ts&setup=true"

import "./return-item-report.vue?vue&type=style&index=0&id=26b1975c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b1975c"]])

export default __exports__